module.exports = import("https://aapn.prod.westus.aks.az.albertsons.com/aapn-experiment-ui//remoteEntry.js");;